// Frontend Configuration

// Detect local development mode (used for API URL defaults only, NOT for auth)
const isLocalDev = window.location.hostname === 'localhost' ||
                   window.location.hostname.startsWith('172.') ||
                   window.location.hostname.startsWith('192.') ||
                   window.location.protocol !== 'https:';

export const config = {
  // Environment
  isLocalDev,

  // API Configuration - localhost for Windows development
  apiUrl: process.env.REACT_APP_API_URL || (isLocalDev ? 'http://localhost:8001' : 'https://your-api-gateway-url.execute-api.us-east-1.amazonaws.com'),
  // SST strips the $default stage suffix from REACT_APP_WS_URL during env var
  // injection (the $ is treated as a shell variable). We append it at runtime.
  wsUrl: (() => {
    const raw = (process.env.REACT_APP_WS_URL || (isLocalDev ? 'ws://localhost:3001' : '')).replace(/\/+$/, '');
    // Local dev URL has no stage; deployed API Gateway URLs need /$default
    return raw && !isLocalDev ? raw + '/$default' : raw;
  })(),

  // OKTA Configuration
  // Works for both local (http://localhost:3000) and deployed environments.
  // For org-level Okta (issuer has no /oauth2 path), the token audience is the clientId.
  // Ensure http://localhost:3000/login/callback is registered as a redirect URI in the Okta app.
  okta: {
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '',
    issuer: process.env.REACT_APP_OKTA_ISSUER || '',
    redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI || (window.location.origin + '/login/callback'),
    // offline_access is required to receive a refresh token from Okta.
    // Without it the SDK can only use a 1-hour access token; with it the SDK
    // silently renews the access token using the refresh token for as long as
    // the Okta session is alive (typically 24h–90 days per org policy).
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
  },

  // File Upload Configuration
  fileUpload: {
    maxFileSize: 10 * 1024 * 1024, // 10MB
    maxTotalSize: 50 * 1024 * 1024, // 50MB
    acceptedTypes: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/svg+xml': ['.svg'],
      'application/pdf': ['.pdf'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      'text/plain': ['.txt'],
      'text/yaml': ['.yaml', '.yml'],
      'application/json': ['.json'],
    },
  },
};
